export const convertChainIdToDecimal = (chainId: string): string =>
  chainId.startsWith('0x') ? parseInt(chainId, 16).toString() : chainId;
